if (!customElements.get('product-card-color-swatches')) {
  class ProductCardColorSwatches extends HTMLElement {
    constructor() {
      super();

      this.swatchInputs = this.querySelectorAll('input');
      this.swatchLabels = this.querySelectorAll('label');
      this.productCard = this.closest('[data-product-card]');
      this.productCardImage = this.productCard.querySelector('[data-product-card-image]');
      this.productCardHoverImage = this.productCard.querySelector('[data-product-card-hover-image]');
      this.productCardShowAllSwatchButtons = this.productCard.querySelectorAll('[data-product-card-show-all-swatches]');
      this.fieldSet = this.productCard.querySelector('fieldset');
      this.productImages = JSON.parse(this.productCard.querySelector('[data-product-images]')?.innerHTML) || false;

      if (this.swatchInputs.length) {
        this.swatchInputs.forEach((swatchInput) => {
          swatchInput.addEventListener('click', this.updateImage.bind(this));
        });
      }

      if (this.swatchLabels.length) {
        this.swatchLabels.forEach((swatchLabel) => {
          swatchLabel.addEventListener('mouseenter', this.prefetchImage.bind(this));
        });
      }

      if (this.productCardShowAllSwatchButtons.length) {
        this.productCardShowAllSwatchButtons.forEach((button) => {
          button.addEventListener('click', this.showAllSwatches.bind(this));
        });
      }
    }

    updateImage(event) {
      this.deactivateSwatch();
      const eventTarget = event.target
      const eventImage = eventTarget.getAttribute('data-image');
      eventTarget.classList.add('active');

      if (eventImage) {
        const selectedSwatchInput = Array.from(this.swatchInputs).find((swatchInput) => {
          return swatchInput.getAttribute('data-image') === eventImage;
        })
  
        if(selectedSwatchInput) {
          if (this.productCardImage) {  
            this.productCardImage.removeAttribute('srcset');
            this.productCardImage.setAttribute('src', eventImage);
          }
  
          if (this.productCardHoverImage && selectedSwatchInput.getAttribute('data-hover-image')) {
            this.productCardHoverImage.removeAttribute('srcset');
            this.productCardHoverImage.setAttribute('src', selectedSwatchInput.getAttribute('data-hover-image'));
          }
        }

        return
      }

      this.fetchImage({eventTarget});
    }

    prefetchImage(event) {
      const eventTarget = event.target.previousElementSibling

      if (!eventTarget.hasAttribute('data-swatch-input')) {
        return
      }

      const eventImage = eventTarget.getAttribute('data-image');
      const renderImage = false
      const prefetch = true

      if (eventImage) {
        return
      }

      this.fetchImage({eventTarget, renderImage, prefetch});
    }

    fetchImage({eventTarget, renderImage = false, prefetch = false}) {
      const values = eventTarget.getAttribute('data-option-value-id');
      const handle = eventTarget.getAttribute('data-handle');

      if (values && handle) {
        this.fetchProduct({
          handle,
          values,
          callback: this.getAvailableVariantInfo({handle, eventTarget, renderImage, prefetch})
        });
      }
    }

    getAvailableVariantInfo({handle, eventTarget, renderImage = false, prefetch = false}) {
      return (html) => {
        const variantDataSelector = renderImage ? '[data-selected-variant]' : '[data-first-available-variant-value-ids]';
        const container = html.querySelector(`[data-product-handle="${handle}"]`);
        if (!container) {
          return;
        }

        const availableVariantData = container.querySelector(`variant-selects ${variantDataSelector}`)?.innerHTML;

        if (!availableVariantData) {
          return;
        }

        if (!renderImage) {
          const newValues = JSON.parse(availableVariantData);
          const willRenderImage = true

          this.fetchProduct({
            handle,
            values: newValues,
            callback: this.getAvailableVariantInfo({
              handle,
              eventTarget,
              renderImage: willRenderImage,
              prefetch
            })
          });

          return
        }

        this.renderFetchedImages({availableVariantData, eventTarget, prefetch});
      };
    }

    renderFetchedImages({availableVariantData, eventTarget, prefetch = false}) {
      const data = JSON.parse(availableVariantData);

      if (!data) {
        return
      }

      const {featured_image} = data
      const image = featured_image?.src;
      if (!image) {
        return
      }

      eventTarget.dataset.image = image

      if (!prefetch) {
        this.productCardImage.removeAttribute('srcset');
        this.productCardImage.setAttribute('src', image);
      }

      if (this.productImages) {
        const imageIndex = this.productImages.findIndex((productImage) => {
          return productImage === image;
        })

        if (!imageIndex || imageIndex === -1) {
          return
        }

        const hoverImageIndex = imageIndex + 1 === this.productImages.length ? 0 : imageIndex + 1;
        const hoverImage = this.productImages[hoverImageIndex];
        eventTarget.dataset.hoverImage = hoverImage

        if (!prefetch) {
          this.productCardHoverImage.removeAttribute('srcset');
          this.productCardHoverImage.setAttribute('src', hoverImage);
        }
      }
    }
  
    fetchProduct({handle, values, callback}) {
      const requestUrl = `/products/${handle}?option_values=${values}`;
      this.abortController?.abort();
      this.abortController = new AbortController();

      fetch(requestUrl, { signal: this.abortController.signal })
        .then((response) => response.text())
        .then((responseText) => {
          this.pendingRequestUrl = null;
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          callback(html);
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted by user');
          } else {
            console.error(error);
          }
        });
    }

    deactivateSwatch() {
      Array.from(this.swatchInputs).find((swatchInput) => {
        return swatchInput.classList.contains('active');
      })?.classList.remove('active');
    }

    showAllSwatches() {
      this.swatchInputs.forEach((swatchInput) => {
        swatchInput.classList.remove('d-none');
      });

      this.swatchLabels.forEach((swatchLabel) => {
        swatchLabel.classList.remove('d-none');
      });

      this.productCardShowAllSwatchButtons.forEach((button) => {
        button.remove();
      });

      this.setAttribute('tabindex', '0');
      this.focus();
    }
  }

  customElements.define('product-card-color-swatches', ProductCardColorSwatches);
}